import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { TrackerElevation } from '../../../../models/tracker';
import { selectUser } from '../../../../features/user/user.selectors';
import { Observable } from 'rxjs';
import {
  selectElevationById,
} from '../../../../features/tracker/tracker.selectors';

@Component({
    selector: 'elevation-card',
    templateUrl: './elevation-card.component.html',
    styleUrls: ['../card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ElevationCardComponent {

  private _elevationId!: string;

  @Input({ required: true })
  set elevationId(value: string) {
    this._elevationId = value;
    this.elevation$ = this.store.select(selectElevationById(value));
  }
  elevation$!: Observable<TrackerElevation | undefined>;

  readonly currentUser$ = this.store.select(selectUser);

  constructor(private store: Store) {
  }
}
